import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import HeaderComponent from "../component/HeaderComponent";
import MobileAppNavigation from "../component/MobileAppNavigation";
import Footer from "../component/Footer";
import DesktopFloating from "../component/DesktopFloating";
import Menu from "../component/Menu";
import AuthContext from "../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { isEmpty } from "lodash";

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  const setMenuModal = useContextSelector(AuthContext, (ctx) => ctx.setMenuModal);
  const menuModal = useContextSelector(AuthContext, (ctx) => ctx.menuModal);
  const showCasino = useContextSelector(AuthContext, (ctx) => ctx.showCasino);
  const showCasinoUrl = useContextSelector(AuthContext, (ctx) => ctx.showCasinoUrl);

  return (
    <>
      <HeaderComponent />
      {showCasino && !isEmpty(showCasinoUrl) ? (
        <div data-v-7bae40b2 className="seamless-wrap br_main">
          <iframe
            data-v-7bae40b2
            id="seamless-game"
            allowFullScreen="allowfullscreen"
            webkitallowfullscreen
            oallowfullscreen
            msallowfullscreen
            mozallowfullscreen
            src={showCasinoUrl}
            className="seamless-iframe"
          />
        </div>
      ) : (
        pathname === "/casino/hot" ? <div className="chorki-hot-page-background">{children}</div> : children
      )}
      {menuModal && <Menu setMenuModal={setMenuModal} />}
      <Footer />
      <DesktopFloating />
      <MobileAppNavigation />
    </>
  );
};

export default Layout;
